export default __webpack_public_path__ + "static/media/empty-projects.e29c51f2.svg";